import UploadImageInput from 'app/atoms/UploadImageInput';
import { countries } from 'constants/Countries';
import React, { useState, Fragment, useEffect } from 'react';
import './styles.scss';
import { PersonalProfileEditFormProps } from './types';
import { Col, Form } from 'react-bootstrap';
import { useForm, useFormContext } from 'react-hook-form';
import PhoneInputControlled from '../../atoms/PhoneInputControlled/PhoneInputControlled';
import usePost from '../../../services/usePost';
import { connect } from 'react-redux';
import { isEmpty } from '../../../utils/utils';
import { setUrbainUser } from '../../../redux/user/user.actions';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import { Controller } from 'react-hook-form';
import GoogleAutocompleteControlled from '../../atoms/GoogleAutocompleteControlled/GoogleAutocompleteControlled';

const PersonalProfileEditForm = (props: PersonalProfileEditFormProps) => {
  const { urbainUser, setUrbainUser, countryInfo } = props;

  const {
    register,
    handleSubmit,
    getValues,
    control,
    reset,
    setValue,
    formState: { errors }
  } = useFormContext();

  const [uploadResult, uploadRequest] = usePost({
    method: 'POST',
    url: `/profile/${urbainUser?.UserID}`,
    defaultValue: {}
  });

  const [userWithoutPhoto, deletePhoto] = usePost({
    method: 'DELETE',
    url: `/profilephoto/${urbainUser?.UserID}`,
    defaultValue: {}
  });

  const [imageUploadResult, imageUploadRequest] = usePost({
    method: 'POST',
    url: `/profilephoto/${urbainUser?.UserID}`,
    defaultValue: {},
    fileToSend: 'photo'
  });

  useEffect(() => {
    reset(urbainUser);
  }, [urbainUser]);

  useEffect(() => {
    if (uploadResult && !isEmpty(uploadResult)) {
      setUrbainUser(uploadResult.data);
      props.onSaved();
    }
  }, [uploadResult]);

  useEffect(() => {
    if (imageUploadResult?.data) {
      setUrbainUser(imageUploadResult.data);
    }
  }, [imageUploadResult]);

  useEffect(() => {
    if (userWithoutPhoto?.data) {
      setUrbainUser(userWithoutPhoto.data);
    }
  }, [userWithoutPhoto]);

  const onSubmit = (data: any) => {
    data.PhotoURL = urbainUser.PhotoURL;
    uploadRequest(data);
  };
  const onProfileImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    imageUploadRequest({ photo: event.target.files![0] });
  };
  const onProfileImageDelete = () => {
    deletePhoto();
  };
  const [isEmergencyFamilyForm, setIsEmergencyFamilyForm] = useState<boolean>(!!urbainUser?.EmergencyName);
  return (
    <div className="__PersonalProfileEditForm font_lato">
      {urbainUser && (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="__details-section">
            <h6 className="__title">
              Legal name & Photo <span className="blue-text">*</span>
            </h6>
            <div className="d-flex align-items-center">
              <UploadImageInput
                name="profileImage"
                onDelete={onProfileImageDelete}
                onChange={onProfileImageChange}
                value={urbainUser?.PhotoURL || 'https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg'}
                className="__upload-image-input-field"
              />

              <div className="f1">
                <Form.Row>
                  <Form.Group as={Col} controlId="formName">
                    <Form.Label className="gray-label">Name</Form.Label>
                    <Form.Control
                      defaultValue={urbainUser.FirstName}
                      placeholder="Name"
                      {...register('FirstName', {
                        required: 'First name required'
                      })}
                    />
                    {errors.FirstName && (
                      <Form.Control.Feedback type="invalid" className="display-block">
                        {errors.FirstName.message || 'Error'}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} controlId="formLastName">
                    <Form.Label className="gray-label">Last Name</Form.Label>
                    <Form.Control
                      defaultValue={urbainUser.LastName}
                      placeholder="Last Name"
                      {...register('LastName', {
                        required: 'Last name required'
                      })}
                    />
                    {errors.LastName && (
                      <Form.Control.Feedback type="invalid" className="display-block">
                        {errors.LastName.message || 'Error'}
                      </Form.Control.Feedback>
                    )}
                    <Form.Text>
                      <p className="__helper-text">This is the name on your travel document, which could be a license or a passport.</p>
                    </Form.Text>
                  </Form.Group>
                </Form.Row>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center __details-section __how-do-you-identify-section">
            <h6 className="__title m-0">How do you identify?</h6>
            <div className="__radio-inputs-wrapper">
              <Form.Check
                inline
                label="He/Him"
                type="radio"
                id={`he-him`}
                value={'male'}
                {...register('Pronoun')}
                defaultChecked={!urbainUser.Pronoun || urbainUser.Pronoun === 'male'}
              />
              <Form.Check
                inline
                label="Her/She"
                type="radio"
                id={`she-her`}
                value={'female'}
                {...register('Pronoun')}
                defaultChecked={urbainUser.Pronoun === 'female'}
              />
              <Form.Check
                inline
                label="Them/They"
                type="radio"
                id={`Them/They`}
                value={'couple'}
                {...register('Pronoun')}
                defaultChecked={urbainUser.Pronoun === 'couple'}
              />
            </div>
          </div>
          <div className="__details-section">
            <Form.Row>
              <Form.Group as={Col} controlId="formBirth">
                <Form.Label className="gray-label">Date of birth</Form.Label>
                <Controller
                  name={'DOB'}
                  control={control}
                  rules={{ required: 'Birth date required' }}
                  defaultValue={urbainUser.DOB}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <DateRangePicker
                        onApply={value => onChange(value)}
                        initialSettings={{
                          singleDatePicker: true,
                          showDropdowns: true,
                          startDate: urbainUser.DOB || '2000-01-01',
                          minYear: 1901,
                          locale: {
                            format: 'YYYY-MM-DD'
                          },
                          maxYear: parseInt(moment().subtract(18, 'years').format('YYYY'), 10),
                          maxDate: moment().subtract(18, 'years')
                        }}
                      >
                        <Form.Control type="text" placeholder="Enter Date" value={value} />
                      </DateRangePicker>
                    );
                  }}
                />

                {errors.DOB && (
                  <Form.Control.Feedback type="invalid" className="display-block">
                    {errors.DOB.message || 'Error'}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Form.Row>
          </div>
          <div className="__details-section">
            <h6 className="__title">
              Email address <span className="blue-text">*</span>
            </h6>
            <p className="__subtitle mt-3 mb-3">Use an address you’ll always have access to.</p>
            <Form.Row>
              <Form.Group as={Col} controlId="formEmail">
                <Form.Label className="gray-label">Email</Form.Label>
                <Form.Control
                  type="email"
                  defaultValue={urbainUser.Email}
                  placeholder="Enter email"
                  {...register('Email', {
                    required: 'Email required',
                    pattern: {
                      value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                      message: 'Email not valid.'
                    }
                  })}
                />
                {errors.Email && (
                  <Form.Control.Feedback type="invalid" className="display-block">
                    {errors.Email.message || 'Error'}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Form.Row>
          </div>
          <div className="__details-section __phone-number-section">
            <Form.Row>
              <Form.Group as={Col} controlId="formPhone" className="phone-input">
                <Form.Label className="gray-label">Phone</Form.Label>
                <PhoneInputControlled
                  control={control}
                  name={'PhoneNumber'}
                  defaultValue={urbainUser.PhoneNumber}
                  defaultCountry={countryInfo?.country_code?.toLowerCase()}
                  handleChangeCountry={(countryCode: string) => setValue('PhoneNumberCode', countryCode)}
                />
              </Form.Group>
            </Form.Row>
          </div>
          <div className="__details-section">
            <h6 className="__title m-0">Address</h6>
            <p className="__subtitle  mt-3 mb-3">Use a permanent address where you can receive mail.</p>
            {urbainUser.ExtendedAddress && (
              <p className={'mb-3'}>
                <strong>Last known address: </strong> {urbainUser.ExtendedAddress}
              </p>
            )}
            <Form.Row>
              <Form.Group as={Col} controlId="formGridAddress" xs={12}>
                <Form.Label className="form-label-info required">Address</Form.Label>
                <GoogleAutocompleteControlled
                  region={{ region: 'GB' }}
                  selectProps={{
                    styles: {
                      container: (provided: any) => ({
                        ...provided,
                        flexGrow: 1
                      })
                    }
                  }}
                  streetNumberFormField={{ name: 'StreetNumber', rules: { required: true } }}
                  addresFormField={{ name: 'StreetAddress', rules: { required: true } }}
                  extendedAddresFormField={{ name: 'ExtendedAddress' }}
                  localityFormField={{ name: 'Locality', rules: { required: true } }}
                  regionFormField={{ name: 'Region' }}
                  postalCodeFormField={{ name: 'PostalCode', rules: { required: true } }}
                  countryFormField={{ name: 'CountryName', rules: { required: true } }}
                />
                {errors.StreetNumber && (
                  <Form.Control.Feedback type="invalid" className="display-block">
                    {errors.StreetNumber.message || 'Number is required.'}
                  </Form.Control.Feedback>
                )}
                {errors.PostalCode && (
                  <Form.Control.Feedback type="invalid" className="display-block">
                    {errors.PostalCode.message || 'Zip Code is required.'}
                  </Form.Control.Feedback>
                )}
                {errors.StreetAddress && (
                  <Form.Control.Feedback type="invalid" className="display-block">
                    {errors.StreetAddress.message || 'Street address is required.'}
                  </Form.Control.Feedback>
                )}
                {errors.Locality && (
                  <Form.Control.Feedback type="invalid" className="display-block">
                    {errors.Locality.message || 'Locality is required.'}
                  </Form.Control.Feedback>
                )}
                {errors.CountryName && (
                  <Form.Control.Feedback type="invalid" className="display-block">
                    {errors.CountryName.message || 'Country is required.'}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Form.Row>
          </div>
          <div className="__details-section">
            <h6 className="__title m-0">Emergency contact</h6>
            <p className="__subtitle  mt-3 mb-2">
              A trusted contact we can alert in an urgent situation.{' '}
              <button className="blue-text __normal-btn" type="button" onClick={() => setIsEmergencyFamilyForm(true)}>
                Add if you have such a person.
              </button>
            </p>
            {isEmergencyFamilyForm && (
              <Fragment>
                <Form.Row>
                  <Form.Group as={Col} controlId="formName">
                    <Form.Label className="gray-label">Name</Form.Label>
                    <Form.Control placeholder="Name" {...register('EmergencyName')} defaultValue={urbainUser.EmergencyName} />
                    {errors.EmergencyName && (
                      <Form.Control.Feedback type="invalid" className="display-block">
                        {errors.EmergencyName.message || 'Error'}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Group as={Col} controlId="formGridState">
                    <Form.Label className="form-label-info required gray-label">Relationship</Form.Label>
                    <Form.Control as="select" defaultValue={urbainUser.EmergencyRelationship} {...register('EmergencyRelationship')}>
                      <option value="">Choose...</option>
                      <option value="Husband">Husband</option>
                      <option value="Wife">Wife</option>
                      <option value="Father">Father</option>
                      <option value="Mother">Mother</option>
                      <option value="Brother">Brother</option>
                      <option value="Sister">Sister</option>
                      <option value="Son">Son</option>
                      <option value="Daughter">Daughter</option>
                    </Form.Control>
                    {errors.EmergencyRelationship && (
                      <Form.Control.Feedback type="invalid" className="display-block">
                        {errors.EmergencyRelationship.message || 'Error'}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} controlId="formGridpreferredLanguage">
                    <Form.Label className="form-label-info required gray-label">Preferred Language</Form.Label>
                    <Form.Control as="select" defaultValue={urbainUser.EmergencyPreferredLanguage} {...register('EmergencyPreferredLanguage')}>
                      <option value="">Choose...</option>
                      <option value="English">English</option>
                      <option value="French">French</option>
                      <option value="Spenish">Spenish</option>
                    </Form.Control>
                    {errors.EmergencyPreferredLanguage && (
                      <Form.Control.Feedback type="invalid" className="display-block">
                        {errors.EmergencyPreferredLanguage.message || 'Error'}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} controlId="formEmailRelative">
                    <Form.Label className="gray-label">Email</Form.Label>
                    <Form.Control
                      defaultValue={urbainUser.EmergencyEmail}
                      type="email"
                      placeholder="Enter email"
                      {...register('EmergencyEmail', {
                        pattern: {
                          value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                          message: 'Email not valid.'
                        }
                      })}
                    />
                    {errors.EmergencyEmail && (
                      <Form.Control.Feedback type="invalid" className="display-block">
                        {errors.EmergencyEmail.message || 'Error'}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} controlId="formPhoneRelative" className="phone-input">
                    <Form.Label className="gray-label">Phone</Form.Label>
                    <PhoneInputControlled
                      control={control}
                      name={'EmergencyPhone'}
                      defaultCountry={countryInfo?.country_code?.toLowerCase()}
                      defaultValue={urbainUser.EmergencyPhone}
                      handleChangeCountry={(countryCode: string) => setValue('EmergencyPhoneCode', countryCode)}
                    />
                  </Form.Group>
                </Form.Row>
              </Fragment>
            )}
            <div className="d-flex mt-4">
              <button className="__btn __primary" onClick={() => console.log(getValues())}>
                Save
              </button>
              <button className="__btn __grey-text" type="button" onClick={() => props.onCancel()}>
                Cancel
              </button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    setUrbainUser: (user: any) => dispatch(setUrbainUser(user))
  };
};

const mapStateToProps = (state: any) => ({
  urbainUser: state.user.urbainUser,
  countryInfo: state.countryInfo
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalProfileEditForm);
